import Main from "src/components/core/Main";

import DashboardSeller from "./seller/DashboardSeller";
import DashboardAdmin from "./admin/DashboardAdmin";
import { White } from "src/styles/color";
import { useAuth } from "src/hooks/useAuth";

function PerformanceDashboard({ open }) {
  const { user } = useAuth();
  return (
    <Main
      open={open}
      sx={{
        backgroundColor: White,
      }}
    >
      {user?.role_id === 1 ? <DashboardAdmin /> : <DashboardSeller />}
    </Main>
  );
}
export default PerformanceDashboard;
